export const newKeyIssueId = () => Array.from(crypto.getRandomValues(new Uint8Array(12)),
  (byte) => byte.toString(16).padStart(2, "0")).join("")

export const withoutKeyIssues = (observation) => {
  if (!observation) return observation
  const { riskMatrixItems, keyIssues, keyIssueMatrixItems, ...fields } = observation
  return fields
}

// Upgrade cached reports from older app versions without losing offline data.
export const normalizeReportMatrix = (record) => {
  if (!record) return record
  const observations = record.observations || []
  const items = [...(record.keyIssueMatrixItems || [])]
  const ids = new Set(items.map((item) => String(item._id || item.id)))
  for (const observation of observations) {
    for (const risk of observation.riskMatrixItems || observation.keyIssues || observation.keyIssueMatrixItems || []) {
      if (ids.has(String(risk._id || risk.id))) continue
      items.push({ ...risk, observationId: observation._id, reportId: record.report?._id || observation.reportId,
        siteId: observation.siteId || record.report?.siteId, templateId: observation.templateId })
      ids.add(String(risk._id || risk.id))
    }
  }
  return { ...record, observations: observations.map(withoutKeyIssues), keyIssueMatrixItems: items }
}

// A joined view for the matrix editor/importer; persisted observations stay flat.
export const observationsWithKeyIssues = (observations = [], items = []) => observations.map((observation) => ({
  ...withoutKeyIssues(observation),
  keyIssues: items.filter((item) => String(item.observationId) === String(observation._id) && item.isActive !== false),
}))

const EMPTY_KEY_ISSUES = []
export const selectKeyIssueMatrixItems = (state, reportId) => {
  const report = reportId ? state?.auditReports?.allReportsData?.[reportId] : state?.auditReports?.currentReportData
  return report?.keyIssueMatrixItems || state?.keyIssueMatrix?.items || EMPTY_KEY_ISSUES
}

export const mergePendingMatrix = (serverRecord, localRecord) => {
  const record = normalizeReportMatrix(serverRecord)
  const pending = localRecord?.pendingKeyIssueChanges || record.pendingKeyIssueChanges || []
  const items = new Map((record.keyIssueMatrixItems || []).map((item) => [String(item._id), item]))
  for (const change of pending) {
    if (change.action === "delete") items.delete(String(change.item._id))
    else items.set(String(change.item._id), change.item)
  }
  const mergeLocal = (server = [], local = []) => [
    ...server,
    ...local.filter((item) => item._offlineQueued && !server.some((saved) => saved._id === item._id)),
  ]
  return { ...record, keyIssueMatrixItems: [...items.values()], pendingKeyIssueChanges: pending,
    observations: mergeLocal(record.observations, localRecord?.observations),
    files: mergeLocal(record.files, localRecord?.files).map((file) => {
      const local = (localRecord?.files || []).find((entry) => entry._offlineQueued && entry._id === file._id)
      return local ? { ...file, ...local, fileDescription: local.fileDescription || file.fileDescription } : file
    }) }
}
